import { render, staticRenderFns } from "./notHd.vue?vue&type=template&id=f985bfcc&scoped=true&"
import script from "./notHd.vue?vue&type=script&lang=js&"
export * from "./notHd.vue?vue&type=script&lang=js&"
import style0 from "./notHd.vue?vue&type=style&index=0&id=f985bfcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f985bfcc",
  null
  
)

export default component.exports